import React, { useContext } from 'react';
import Attachments from '../../Organismns/Attachments';
import { EditableEmailTemplateProperty } from '../../Atoms/EditableProperties/EditableEmailTemplateProperty';
import TooltipButton from '../../Atoms/buttons/TooltipButton';
import ChatMessageAttachmentButton from '../Message/ChatMessageAttachmentButton';
import { EditableDivInput } from '../../Atoms/inputs/EditableDivInput';
import { HtmlPlaceholderFormatter } from '../../Atoms/Formatter/HtmlPlaceholderFormatter';
import { MessageContext } from '../../Service/Context/MessageContext';

export const EmailTemplateEditor = ({ value, preChange, messageType, templateName }) => {
  const { message, changeMessage, saveMessage } = useContext(MessageContext);

  function deleteFileAttachment(index) {
    const tmpFiles = message.attachments;
    tmpFiles.splice(index, 1);
    saveMessage({ attachments: tmpFiles });
  }

  function deleteDocumentAttachment(index) {
    const tmpDocs = message.documentBlueprints;
    tmpDocs.splice(index, 1);
    saveMessage({ documentBlueprints: tmpDocs });
  }

  const styles = {
    subjectAndIcon: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    icon: {
      flex: 1,
      minWidth: 20,
      float: 'right',
      alignItems: 'center',
    },
    container: {
      display: 'flex',
    },
    messageContainer: {
      flex: 2,
      marginTop: 10,
      maxWidth: '100%',
    },
    attachmentContainer: {
      marginTop: 10,
      marginBottom: 10,
    },
    fullWidth: {
      flex: 1,
    },
  };

  if (!message) {
    return null;
  }

  return (
    <div style={styles.container} className="message-email-pane">
      <div style={styles.messageContainer}>
        <div style={styles.subjectAndIcon}>
          <div style={styles.fullWidth}>
            <EditableEmailTemplateProperty
              patchField="subject"
              messageType={messageType}
              templateName={templateName}
              preChange={preChange}
              changeHandler={changeMessage}
              email={value}
              placeholder="message.subject"
              name="subject"
              editFormatter={EditableDivInput}
              labelFormatter={HtmlPlaceholderFormatter}
              settings
              disableTextSelectionPopover
            />
          </div>
          <TooltipButton
            icon="QUESTION"
            id="help-message-email-pane"
            text="help.message.email.pane"
            style={styles.icon}
          />
        </div>

        <div style={styles.attachmentContainer}>
          <Attachments
            attachments={message.attachments}
            documentBlueprints={message.documentBlueprints}
            deleteFileAttachment={deleteFileAttachment}
            deleteDocumentAttachment={deleteDocumentAttachment}
          />
          <ChatMessageAttachmentButton emailTemplate={messageType} templateName={templateName} />
        </div>
        <EditableEmailTemplateProperty
          patchField="message"
          messageType={messageType}
          templateName={templateName}
          preChange={preChange}
          changeHandler={changeMessage}
          email={value}
          placeholder="Nachricht"
          name="message"
          big
          editFormatter={EditableDivInput}
          labelFormatter={HtmlPlaceholderFormatter}
          settings
        />
      </div>
    </div>
  );
};
